<template>
  <div>
    <VBtn
      color="#0A5894"
      height="50px"
      class="white--text ml-4"
      @click="showDialog"
    >
      <img src="@/images/program-filter-icon.png">
      <span 
        class="font-weight-medium pl-2"
        style="font-size: 15px;"
      >
        {{ buttonText }} ({{ selectedItems.length }})
      </span>
    </VBtn>
    <Dialog
      enable-footer-slots
      max-width="540px"
      custom-class="filter-dialog"
      :dismissable="false"
      :enable-save-button="false"
      :enable-cancel-button="false"
      :is-dialog-open="dialogs.filter"
      :title="buttonText"
    >
      <template #title>
        <h3 class="text-h5 font-weight-bold">
          {{ buttonText }}
        </h3>
        <p class="my-2">
          {{ description }}
        </p>
      </template>
      <VRow>
        <VCol 
          cols="12"
          class="d-flex px-5"
          style="box-shadow: 0px 4px 14px 0px #00000014;"
        >
          <TextField
            v-model="search"
            clearable
            single-line
            hide-details
            append-icon="search"
            label="Search..."
            class="search-field"
            @click:clear="search = ''"
          />
          <VBtn 
            text
            color="#3B79A9"
            class="text-decoration-underline"
            @click="filterBy = availableItems.map(item => item.id)"
          >
            <span class="text-body-2 font-weight-bold">Select All</span>
          </VBtn>
          <VBtn 
            text
            color="#3B79A9"
            class="text-decoration-underline"
            :disabled="filterBy.length === 0 || availableItems.length === 1"
            @click="filterBy = []"
          >
            <span class="text-body-2 font-weight-bold">Clear</span>
          </VBtn>
        </VCol>
        <VCol 
          cols="12"
          style="overflow: hidden auto; max-height: 240px;"
        >
          <VList>
            <VListItem
              v-for="(item, index) in availableItems"
              ripple
              :key="index"
              :disabled="availableItems.length === 1"
              @click="onClickItem(item)"
            >
              <VListItemAction style="max-width: 26px">
                <VIcon :color="filterBy.includes(item.id) ? '#0A5894' : '#BBD1EA'">
                  {{ filterBy.includes(item.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank' }}
                </VIcon>
              </VListItemAction>
              <VListItemContent>
                <VListItemTitle class="text-body-2 font-weight-bold">
                  {{ item.title }}
                </VListItemTitle>
              </VListItemContent>
            </VListItem>
          </VList>
        </VCol>
      </VRow>
      <template #footer-center>
        <VRow>
          <VCol cols="6">
            <VBtn
              block
              color="#DCDCDC"
              height="50px"
              @click="onCancel"
            >
              <span class="text-body-1 font-weight-medium">Cancel</span>
            </VBtn>
          </VCol>
          <VCol cols="6">
            <VBtn
              block
              color="#0A5894"
              height="50px"
              class="white--text"
              :disabled="filterBy.length === 0"
              @click="onApply"
            >
              <span class="text-body-1 font-weight-medium">Apply</span>
            </VBtn>
          </VCol>
        </VRow>
      </template>
    </Dialog>
  </div>
</template>
<script>
export default {
  props: {
    buttonText: {
      type: String,
      default: "Filter",
    },
    description: {
      type: String,
      default: "Select the items you want to filter.",
    },
    items: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: "",
      filterBy: [],
      dialogs: {
        filter: false,
      },
    };
  },
  computed: {
    availableItems() {
      if(this.search.trim()) {
        return this.items.filter(item => item.title.toLowerCase().includes(this.search.toLowerCase()));
      }
      return this.items;
    },
  },
  methods: {
    showDialog() {
      this.filterBy = this.selectedItems.length ? [...this.selectedItems] : [];
      this.dialogs.filter = true;
    },
    onClickItem(item) {
      const index = this.filterBy.indexOf(item.id);
      if (index === -1) {
        this.filterBy.push(item.id);
      } else {
        this.filterBy.splice(index, 1);
      }
    },
    onCancel() {
      this.search = "";
      this.filterBy = [];
      this.dialogs.filter = false;
    },
    onApply() {
      this.$emit("apply", this.filterBy);
      this.onCancel();
    },
  },
}
</script>
<style lang="scss">
.filter-dialog {
  border-radius: 10px;
  .v-card__title {
    word-break: break-word;
    border-radius: 8px 8px 0 0 !important;
    padding: 20px 16px 20px 20px !important;
    height: auto !important;
    flex: none !important;
    background-color: #E3E3E3;
    line-height: 20px;
  }
  .v-card__actions {
    box-shadow: 0px 8px 25px 0px #00000026;
  }
  .search-field {
    :not(.v-input--checkbox):not(.v-input--radio):not(.v-input--switch) fieldset {
      background-color: #FAF9FF !important;
      border: 1px solid var(--Gray-Medium, #666666) !important;
    }
  }
  .mdi-checkbox-marked::before {
    font-size: 24px;
  }
  .v-list-item__action:first-child {
    margin-right: 12px !important;
  }
}
</style>